const {
	convertRouteToMqttTopic,
	convertRouteToRegex,
	convertMqttTopicToRegex,
	getParentRoute,
} = require('./utils');

/** Representation of a topic and it's handler */
class Endpoint {
	/**
	 * @param {string} route
	 * @param {import('./types').MessageHandlerFunc} handler
	 * @param {import('./router')|undefined} router
	 */
	constructor(route, handler, router = undefined) {
		this.route = route;

		/** The handler function associated to this endpoint's route */
		this.handler = handler;

		/** A regex representation of this endpoint's route
		 * @type {RegExp}*/
		this.routeRegex = convertRouteToRegex(this.route);

		/** An mqtt compliant version of this endpoint's route */
		this.mqttTopic = convertRouteToMqttTopic(this.route);

		/** A regex representation of this endpoint's mqtt topic */
		this.mqttTopicRegex = convertMqttTopicToRegex(this.mqttTopic);

		/** The MqttRouter associated to this endpoint if any */
		this.router = router;

		/** True if this endpoint has subRoutes */
		this.isSubRouter = !!this.router;

		/**
		 * If [isSubRouter]{@link Endpoint#isSubRouter} is true, then this is the part of the topic
		 * excluding the /# wildcard.
		 *
		 * Examples:
		 *
		 *      '#'           --->      ''
		 *      'foo/bar/#'   --->      'foo/bar'
		 *      foo/+/bar/#  --->       'foo/+/bar'
		 * @type {RegExp|null}
		 */
		this.parentRouteRegex = null;
		if (this.isSubRouter) {
			this.parentRouteRegex = convertRouteToRegex(getParentRoute(this.route), false);
			this.parentMqttTopicRegex = convertMqttTopicToRegex(
				getParentRoute(this.mqttTopic),
				false
			);
		}
	}
}

module.exports = Endpoint;
